export default "__VITE_ASSET__Crgbolnv__"